import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import EditTwoToneIcon from "@material-ui/icons/EditTwoTone";
import DeleteTwoToneIcon from "@material-ui/icons/DeleteTwoTone";

const useStyles = makeStyles({
	editIcon: {
		cursor: "pointer",
	},
	deleteIcon: {
		marginLeft: "0.5rem",
		cursor: "pointer",
		color: "#dc004e !important",
	},
});

const TableAction = () => {
	const classes = useStyles();
	return (
		<div>
			<EditTwoToneIcon className={classes.editIcon} />
			<DeleteTwoToneIcon className={classes.deleteIcon} />
		</div>
	);
};

export default TableAction;
